import React from 'react'

import { withRouter } from 'react-router-dom'

import { Container, Tab } from 'semantic-ui-react';

import { BreadcrumbHelper } from 'utils';

import {
  PaneInformations,
  PaneExamenList,
} from './panes';

import './style.css';

class HorseScene extends React.Component {

  constructor(props) {
    super(props);

    const { horse } = this.props;

    let panes = [];

    //Pane informations

    panes.push({
      menuItem: {
        content: 'Identité',
        icon: 'address card'
      },
      render: () => {
        return <PaneInformations horse={horse} />
      }
    });

    //Pane examens
    panes.push({
      id: "examens",
      menuItem: {
        content: 'Examens',
        icon: 'stethoscope'
      },
      render: () => {
        return <PaneExamenList horse={horse} key={"examen"} />
      }
    });

    //Select active tab based on hash
    let hash = window.location.hash.trim().substring(1);
    let activeIndex = hash.length > 0 ? null : 0;

    if (!activeIndex) {

      for(let i = 0; i < panes.length; i++) {

        if(panes[i].id === hash) {
          activeIndex = i;
          break;
        }
      }

      //Unknown hash
      if(!activeIndex) {
        activeIndex = 0;
        window.location.hash = '';
      }
    }

    this.state = {
      panes: panes,
      activeIndex: activeIndex
    };

    this.handleTabChange = this.handleTabChange.bind(this);

    this.updateBreadcrumb();
  }

  updateBreadcrumb() {

    const { horse } = this.props;
    const { clinic } = horse;

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');

    // Clinic only
    if(this.props.match.path.startsWith('/clinics/')) {

      BreadcrumbHelper.push('Chevaux', '/clinics/horses');

    } else {

      BreadcrumbHelper.push('Cliniques', '/clinics');
      BreadcrumbHelper.push(clinic.name, `/clinics/${clinic.id}`);
      BreadcrumbHelper.push('Chevaux', `/clinics/${clinic.id}#horses`);
    }

    BreadcrumbHelper.push(horse.name)

    //Active pane
    let pane = this.state.panes[this.state.activeIndex];
    BreadcrumbHelper.push(pane.menuItem.content);

    BreadcrumbHelper.flush();
  }

  handleTabChange(e, { activeIndex }) {
    this.setState({ activeIndex }, this.updateBreadcrumb);

    //Update location hash
    let pane = this.state.panes[activeIndex];
    window.location.hash = pane.id ?? '';
  }

  render() {

    const { panes, activeIndex } = this.state;

    return (
      <React.Fragment>

        <Container>
          <Tab
            id="tabs"
            panes={panes}
            activeIndex={activeIndex}
            menu={{ secondary: false, pointing: true }}
            onTabChange={this.handleTabChange}/>
        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(HorseScene);
